import { render, staticRenderFns } from "./GridPestanaGenerica.vue?vue&type=template&id=35eb86ac&"
import script from "./GridPestanaGenerica.vue?vue&type=script&lang=js&"
export * from "./GridPestanaGenerica.vue?vue&type=script&lang=js&"
import style0 from "./GridPestanaGenerica.vue?vue&type=style&index=0&id=35eb86ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports